import React from "react";
import { Link } from "react-router-dom";
import notFound from "../Assets/img/404.png";

const NotFound = () => {
  return (
    <div className="error-case">
      <div className="container">
        <div className="img-404">
          <img src={notFound} alt="" />
        </div>
        <h2 className="main-title mt-3 mb-3 text-center">
          Oops! this page not found
        </h2>
        <div className="text-center">
          <Link to="/" className="btn green-btn">
            Back To Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
